import styled from 'styled-components';
import device from '../../../components/mediaQueries';

const Title = styled.span`
  font-family: 'Avenir Black', 'Arial Black', sans-serif;
  font-size: 15px;
  color: #f25c5e;
  ${({ cursor }) => (cursor ? 'cursor: pointer' : '')};
  line-height: 40px;
  ${device.mobile`
    line-height: 25px;
  `}
`;

export default Title;
